var ProjectVideo = (function($) {
  function startVideo(player) {
    const video = player.querySelector(".js-project-video");
    if (!video) return;

    video.muted = false;
    video.controls = true;
    video.play().catch(() => {});

    player.classList.add("is-playing");
  }

  function initProjectVideo() {
    const players = document.querySelectorAll(".js-video-player");

    if (!players.length) return;

    players.forEach(player => {
      const video = player.querySelector(".js-project-video");
      const playButton = player.querySelector(".js-video-play");

      if (!video || !playButton) return;

      playButton.addEventListener("click", function() {
        startVideo(player);
      });

      video.addEventListener("click", function() {
        if (video.paused) {
          startVideo(player);
        }
      });

      video.addEventListener("pause", function() {
        player.classList.remove("is-playing");
      });

      video.addEventListener("play", function() {
        player.classList.add("is-playing");
      });
    });
  }

  function init() {
    if (!$(".js-video-player").length) return;
    initProjectVideo();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(ProjectVideo.init);
